import { Controller } from "@hotwired/stimulus"
import { addFromTemplate } from "../helpers/nested_form"

export default class extends Controller {
  static targets = ["template", "container", "record"]

  add(event) {
    event.preventDefault()
    addFromTemplate(this.containerTarget, this.templateTarget.innerHTML, "NEW_INDEX")
  }

  remove(event) {
    event.preventDefault()
    const record = event.target.closest("[data-nested-form-target='record']")
    if (record) {
      const destroyInput = record.querySelector("input[name*='[_destroy]']")
      if (destroyInput) {
        destroyInput.value = "1"
        record.style.display = "none"
      } else {
        record.remove()
      }
    }
  }
}
